// @flow

import styled from "styled-components";
import Icon from "@fdr/static-ui/Icons/";
import { fontCondensed } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";
import { buildText } from "../../_atoms/Text";

const selectorHeight = "48px";

export const AmountSelectorContainer = styled.div`
  width: 104px;
  height: ${selectorHeight};
  overflow: hidden;
  flex: 0 0 auto;
  display: flex;
  border: 1px solid ${buildColor("grey", "300")};
  border-radius: 4px;
  position: relative;
`;

export const WagerNumber = styled.span`
  color: ${buildColor("navy", "700")};
  font-size: 12px;
  font-family: ${fontCondensed};
  letter-spacing: 1px;
`;

export const AmountLabelsWrapper = styled.span`
  width: 100%;
  height: ${selectorHeight};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  padding: 8px 12px;
`;

export const AmountValue = buildText({
  tag: "span",
  fontSize: 16,
  color: buildColor("grey", "D4"),
  uppercase: true,
  ellipsis: true
});

export const SelectIcon = styled(Icon)`
  position: absolute;
  right: 8px;
  top: 22px;
`;

export const SelectList = styled.select.attrs({
  "data-qa-label": "betTicket-amountSelector"
})`
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
